import React, { Component } from 'react'
import TextWithFieldname from '../texts/TextWithFieldname';
import IconRender from '../std/IconRender';
import HelperEnv from '../../helpers/HelperEnv';
import HelperGenerics from '../../helpers/HelperGenerics';
import EnvInfoTable from './EnvInfoTable';

class TableRoutingInfo extends Component {

	showModal = () => {
		var context = {
			siteCode: this.props.dataContext.siteCode,
			journeyType: this.props.dataContext.journeyType,
			renderType: this.props.dataContext.renderType,
			financeJourneyCode: this.props.dataContext.financeJourneyCode,
			isFrom: this.props.dataContext.isFrom,
			colour: this.props.dataContext.colour,
			distributionBrand: this.props.dataContext.distributionBrand,
			countryCode: this.props.dataContext.countryCode,
			languageCode: this.props.dataContext.languageCode,
			customer: {
				clientType: this.props.dataContext.customer.clientType,
				youngestDriverAge: this.props.dataContext.customer.youngestDriverAge,
				postCode: this.props.dataContext.customer.postCode,
			}
		}
		this.props.onOpenModal(context);
	}

	buildEnvironmentsLevelList(environmentsList) {
		const levelEnvironmentList = [];
		for (const key in environmentsList) {
			for (const key2 in environmentsList[key]) {
				const name = environmentsList[key][key2].name;
				if (!levelEnvironmentList.includes(name)) {
					levelEnvironmentList.push(name);
				}
			}
		}
		return levelEnvironmentList;
	}

	getEnvironmentLink(keyEnv, keyEnvLevel, environmentsList) {
		const entries = environmentsList[keyEnv] || [];
		const entry = entries.find(e => e.name === keyEnvLevel);
		const links = this.normalizeEnvLinks(entry && entry.url);

		if (links.length === 0) {
			return null;
		}

		return links.map((link, i) => {
			const label = link.label
				? `${keyEnv} ${keyEnvLevel} (${link.label})`
				: `${keyEnv} ${keyEnvLevel}`;
			return (
				<div key={`${keyEnv}-${keyEnvLevel}-${i}`}>
					{HelperGenerics.renderLink(link.url, null, label)}
				</div>
			);
		});
	}

	// Accepts either "url": "https://..." or "url": [{ "url": "...", "label": "old" }, ...]
	normalizeEnvLinks(url) {
		if (url == null) {
			return [];
		}
		if (Array.isArray(url)) {
			return url.filter(link => link && link.url);
		}
		return [{ url: url, label: null }];
	}

	render() {
		let routingInfo = null;
		if (this.props.routingResp != null) {
			routingInfo = this.props.routingResp.routingInfo;
		}
		const widgetSFS = document.getElementById('widget-sfs');
		const widgetSfsVersion = widgetSFS && widgetSFS.getVersion && widgetSFS.getVersion();
		const environmentsList = HelperEnv.getEnvGatewayTestList();
		const levelEnvironmentList = this.buildEnvironmentsLevelList(environmentsList);

		return (
			<React.Fragment>
				{this.props.settings.isDevelopperView &&
					<div className="col-auto">
						<button className="btn btn-light p-0 px-2" onClick={this.showModal} data-bs-toggle="modal" data-bs-target="#modalRouting" >
							<IconRender name="question-circle" />
						</button>
					</div>
				}
				{this.props != null && this.props !== 0
					&& <div className="modal" tabIndex="-1" id="modalRouting">
						<div className="modal-dialog">
							<div className="modal-content">
								<div className="modal-body">
									{this.props.versionResp != null &&
										this.props.versionResp.version != null && this.props.versionResp.version != null &&
										<h6>VERSION: {this.props.versionResp.version.version} </h6>}
									{widgetSfsVersion && <p>
										Widget SFS version: {widgetSfsVersion.widget_version} - {widgetSfsVersion.build_datetime}
									</p>}
									<TextWithFieldname fieldname='routing information' developperView={this.props.settings.isDevelopperView} complexChild={true}>
										{!this.props.settings.isDevelopperView && <h6>Routing Information </h6>}
										<EnvInfoTable routingInfo={routingInfo}/>
									</TextWithFieldname>	
									{Object.keys(environmentsList).length > 0 && <table className="table table-light table-striped">
										<thead>
											<tr className='table-primary'>
												<th>Environment</th>
												{Object.keys(environmentsList).map((keyEnv, index) => (
													<th key={index}>{keyEnv}</th>
												))}
											</tr>
										</thead>
										<tbody>
											{levelEnvironmentList.map((keyEnvLevel, index) => (
												<tr key={index}>
													<td>
														{keyEnvLevel}
													</td>
													{Object.keys(environmentsList).map((keyEnv, index2) => (
														<td key={index2} >{this.getEnvironmentLink(keyEnv, keyEnvLevel, environmentsList)}</td>
													))}
												</tr>
											))}
										</tbody>
									</table>}
								</div>
							</div>
						</div>
					</div>
				}
			</React.Fragment>
		)
	}
}
export default (TableRoutingInfo)
